/**
 * What: What the picked field holds, shown as it really looks: the whole text in a box, or the picture itself.
 * Transport / data-flow: Dumb renderer over one `field-picker` preview. Choosing which value is the control is decided by
 *   the version chosen in Product context, not here.
 */
import type { FieldPickerPreview } from '@testfeed/shopify-contracts'

function Preview({ preview }: { preview: FieldPickerPreview }) {
  if (preview.kind === 'image')
    return (
      <div className="tf-review-fields__image">
        <s-image src={preview.url} alt={preview.alt} inlineSize="fill" objectFit="contain" />
      </div>
    )
  return (
    <s-box background="subdued" borderRadius="base" padding="base">
      <s-text>{preview.text}</s-text>
    </s-box>
  )
}

export function ReviewFieldValues({
  heading,
  preview,
  note,
}: {
  heading: string
  preview: FieldPickerPreview
  note: string | null
}) {
  return (
    <s-stack direction="block" gap="small-200">
      <s-text type="strong">{heading}</s-text>
      <Preview preview={preview} />
      {note ? <s-text color="subdued">{note}</s-text> : null}
    </s-stack>
  )
}
